const legal = () => {
    document.addEventListener('DOMContentLoaded', function () {
        var checkBox = document.getElementById('chbLegal') as HTMLInputElement;
        checkBox.addEventListener('change',
                () => {
                    var companyInfo = document.getElementById('ContentPlaceHolder1_tblLegal') as HTMLElement;
                    if (checkBox.checked) {
                        companyInfo.style.display = "table";
                    } else {
                        companyInfo.style.display = "none";
                    }
                });
    });
};

export {
    legal
};